import { theme } from 'twin.macro';
import {
  RedeemAction,
  RedeemActionCount,
  RedeemCardWrapper,
  RedeemCoins,
  RedeemCoinsWrapper,
  RedeemImage,
  RedeemInfo,
  RedeemLock,
  RedeemLockIcon,
  RedeemLockText,
  RedeemName,
  RedeemReduction,
} from './RedeemCard.styles';
import GroupCoins from 'assets/icons/coins/Groupcoins.png';
import LockIcon from 'assets/icons/lock.png';
import DoneIcon from 'assets/icons/done.png';
import ExpiredIcon from 'assets/icons/expired.png';
import Hourglass from 'assets/icons/hourglass.png';
import { RedeemCardProps, StateInfo, StateMap } from './RedeemCard.types';
import noImage from 'assets/images/noImage.jpeg';
import { formatNumber } from 'helpers/GlobalHelper';
import { useTranslation } from 'react-i18next';

const RedeemCard = ({
  state,
  name,
  cost,
  reduction,
  img,
  countDown,
  onClick,
}: RedeemCardProps) => {
  const { t } = useTranslation();

  const stateMap: StateMap = {
    locked: {
      text: '',
      icon: LockIcon,
    },
    redeemed: {
      text: 'Redeemed',
      icon: DoneIcon,
    },
    expired: {
      text: 'Expired',
      icon: ExpiredIcon,
    },
  };

  const stateInfo: StateInfo = stateMap[state] || stateMap['locked'];

  return (
    <RedeemCardWrapper state={state}>
      {stateMap[state] && (
        <RedeemLock>
          <RedeemLockIcon src={stateInfo.icon} alt={stateInfo.text} />
          {stateInfo.text && <RedeemLockText>{stateInfo.text}</RedeemLockText>}
        </RedeemLock>
      )}
      {reduction && <RedeemReduction>GET -{reduction}%</RedeemReduction>}
      <RedeemImage src={img || noImage} alt={name} />
      <RedeemInfo>
        <RedeemCoinsWrapper>
          <RedeemCoins src={GroupCoins} alt={cost + ''} />
          {formatNumber(cost)}
        </RedeemCoinsWrapper>
        <RedeemName>{name}</RedeemName>
      </RedeemInfo>
      {!stateMap[state] && (
        <RedeemAction
          width="88%"
          height="3.062rem"
          hasAfter={false}
          isRounded={false}
          bgColor={state === 'onRedeem' ? 'white' : undefined}
          borderColor={theme`colors.darkGray`}
          shadowColor={theme`colors.black`}
          onClick={onClick}
        >
          {state === 'open' ? (
            t('redeemit')
          ) : (
            <RedeemActionCount>
              <RedeemCoins src={Hourglass} alt="countdown" />
              {countDown &&
                `${countDown.hours}:${countDown.minutes}:${countDown.seconds}`}
            </RedeemActionCount>
          )}
        </RedeemAction>
      )}
    </RedeemCardWrapper>
  );
};

export default RedeemCard;
